/**
 * Safe date formatting utilities — handles null, undefined, and invalid date strings
 * without throwing or displaying "Invalid Date".
 */

/** Sanitize date strings with invalid "+00:00Z" suffix (both offset AND Z) */
function sanitize(d: string): string {
  // Fix "+00:00Z" → "Z" (backend sometimes appends Z to timezone-aware ISO strings)
  return d.replace(/\+00:00Z$/, 'Z').replace(/\+00:00z$/, 'Z');
}

/** Format a date string as locale date (e.g. "3/15/2026"). Returns "—" for invalid input. */
export function fmtDate(d: string | null | undefined, opts?: Intl.DateTimeFormatOptions): string {
  if (!d) return '—';
  const dt = new Date(sanitize(d));
  return isNaN(dt.getTime()) ? '—' : dt.toLocaleDateString(undefined, opts);
}

/** Format a date string as locale date+time (e.g. "3/15/2026, 2:30:00 PM"). Returns "—" for invalid input. */
export function fmtDateTime(d: string | null | undefined): string {
  if (!d) return '—';
  const dt = new Date(sanitize(d));
  return isNaN(dt.getTime()) ? '—' : dt.toLocaleString();
}

/** Format a date string as locale time only (e.g. "2:30 PM"). Returns "—" for invalid input. */
export function fmtTime(d: string | null | undefined, opts?: Intl.DateTimeFormatOptions): string {
  if (!d) return '—';
  const dt = new Date(sanitize(d));
  return isNaN(dt.getTime()) ? '—' : dt.toLocaleTimeString(undefined, opts);
}
